export default "__VITE_ASSET__BSkmm4WH__"